import React from 'react'
import TermsAndConditions from '../containers/TermsAndCondition/TermsAndCondition'
import Seo from '../common/Components/Seo/Seo'
import TermsSchema from '../common/Components/StructuredData/TermsSchema'

const TermsAndCondition = () => {
  return (
    <div>
      <Seo
        seo={{
          title: "Terms and Conditions | Airport Parking Deals Booking Terms",
          description: "Read Airport Parking Deals terms and conditions for airport parking bookings, including cancellation policies, refund terms, and service conditions.",
          keywords: "terms and conditions, booking terms, cancellation policy, service terms, airport parking terms"
        }}
      />
      <TermsSchema />
      <div className="w-full bg-[#0C735F] h-28 md:h-[180px]"></div>

      <TermsAndConditions />
    </div>
  )
}

export default TermsAndCondition
